<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoContainer fluid>
      <SoRow>
        <SoCol>
          <SoTooltip
            text="This page is under construction. Please let us know any feedback or if something isn't right via the Send Feedback button."
            location="end"
            offset="30"
          >
            <v-badge content="beta" color="blue">
              <h4 class="text-h4 mr-2">Smart Devices</h4>
            </v-badge>
          </SoTooltip>
        </SoCol>
      </SoRow>
      <SoRow>
        <SoCol :default-width="4" :mobile-width="12">
          <DevicesWidget />
        </SoCol>
        <SoCol :default-width="8" :mobile-width="12">
          <MeterAppointMentHistoryWidget />
        </SoCol>
      </SoRow>
    </SoContainer>
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { MeterpointService } from "@/services/MeterpointService"
  import SoContainer from "@/components/SoContainer.vue"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "../overview/CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "../overview/CustomerAccountInfoRail.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoTooltip from "@/components/SoTooltip.vue"
  import DevicesWidget from "./widgets/DevicesWidget.vue"
  import MeterAppointMentHistoryWidget from "./widgets/MeterAppointmentHistoryWidget.vue"

  export default defineComponent({
    components: {
      SoContainer,
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoRow,
      SoCol,
      DevicesWidget,
      MeterAppointMentHistoryWidget,
      SoTooltip,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        MeterpointService,
      }
    },
  })
</script>
